import { mapActions, mapState } from 'vuex';
import { isBlank } from 'utils/string';

export const financeInfoMixins = {
  data() {
    return {
      specificCompanyEntity: [],
      specificHyperTapBankInfoList: [],
    };
  },
  computed: {
    ...mapState({
      sourcesList: (state) => state['source'].sourcesList,
      sourcesNameList: (state) => state['source'].sourcesNameList,
      sourceLoading: (state) => state['source'].sourceLoading,
      originSourceList: (state) => state['source'].originSourceList,
      affiliatesGroupList: (state) => state['affiliate'].affiliatesGroupList,
      affiliateLoading: (state) => state['affiliate'].affiliateLoading,
      affiliatesNameGroupList: (state) => state['affiliate'].affiliatesNameGroupList,
      affiliates: (state) => state['affiliate'].affiliates,
      companyEntityList: (state) => state['financeInfo'].companyEntityList,
      companyPlatformList: (state) => state['financeInfo'].companyPlatformList,
      companyPlatformEntities: (state) => state['financeInfo'].companyPlatformEntities,
      hyperTapCompanyInfo: (state) => state['financeInfo'].hyperTapCompanyInfo,
      hyperTapCompanyEntities: (state) => state['financeInfo'].hyperTapCompanyEntities,
    }),
  },
  created() {
    this.specificCompanyEntity = [];
    this.getSourceIdsList();
    this.getAffiliateList();
    this.getCompanyInfo();
    this.getHyperTapCompanyInfo();
  },
  methods: {
    ...mapActions({
      getAffiliateList: 'affiliate/getAffiliateList',
      getSourceIdsList: 'source/getSourceIdsList',
      getCompanyInfo: 'financeInfo/getCompanyInfo',
      getHyperTapCompanyInfo: 'financeInfo/getHyperTapCompanyInfo',
    }),
    getHyperTapCompanyAlias(value) {
      if (isBlank(value)) {
        return '';
      }
      return (
        this.hyperTapCompanyEntities.find((item) => item.companyEntity === value)
          ?.companyEntityAlias || ''
      );
    },

    /**
     * 根据 selectedCompanyPlatform 选择 companyEntityList 列表 <br/>
     * 如果需要清空 companyEntityList 列表，确保 $refs.companyEntityOptions 存在
     * @param selectedCompanyPlatform
     * @returns {*[]}
     */
    handleCompanyPlatformChange(selectedCompanyPlatform) {
      this.specificCompanyEntity = [];
      if (this.$refs.companyEntityOptions) {
        this.$refs.companyEntityOptions.$emit('input', null);
      }
      this.companyPlatformEntities.forEach((item) => {
        if (
          item.companyPlatform === selectedCompanyPlatform ||
          selectedCompanyPlatform.includes(item.companyPlatform)
        ) {
          this.specificCompanyEntity = this.specificCompanyEntity.concat(item.companyEntityList);
          return 0;
        }
      });
      return [];
    },

    /**
     * 根据 hyperTapEntity 选择 hyperTapBankInfoList 列表 <br/>
     * 如果需要清空 hyperTapEntity 列表，确保 $refs.companyEntityOptions 存在
     * @param bfiId
     * @returns {*[]}
     */
    handleHyperTapEntityChange(bfiId) {
      this.specificHyperTapBankInfoList = [];
      if (this.$refs.hyperTapEntityBankOptions) {
        this.$refs.hyperTapEntityBankOptions.$emit('input', null);
      }
      this.hyperTapCompanyInfo.forEach((item) => {
        if (item.bfiId === bfiId) {
          this.specificHyperTapBankInfoList = item.bankList;
          return 0;
        }
      });
      return [];
    },
  },
};
